"use client";

import React from "react";
import {
  Controller,
  Control,
  FieldError,
  UseFormRegisterReturn,
} from "react-hook-form";
import { Textarea } from "../ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { Input } from "../ui/input";
import { cn } from "../../lib/utils";

interface FormField2Props {
  label: string;
  name: string;
  placeholder?: string;
  as?: "input" | "textarea" | "select";
  options?: { label: string; value: string }[];
  required?: boolean;
  register?: UseFormRegisterReturn;
  error?: FieldError;
  value?: string;
  onChange?: (value: string) => void;
  control?: Control<any>;
  className?: string;
  disabled?: boolean;
}

export const FormField2: React.FC<FormField2Props> = ({
  label,
  name,
  placeholder,
  as = "input",
  options = [],
  required = false,
  register,
  error,
  value,
  onChange,
  control,
  className,
  disabled,
}) => {
  const renderField = (fieldProps?: any) => {
    if (as === "textarea")
      return (
        <Textarea
          id={name}
          placeholder={placeholder}
          {...(register || fieldProps)}
        />
      );

    if (as === "select")
      return (
        <Select
          value={value || ""}
          placeholder={placeholder}
          options={options}
          onValueChange={(val) => onChange?.(val)}
          {...({} as any)}
          disabled={disabled}
        >
          <SelectTrigger id={name}>
            <SelectValue placeholder={placeholder} />
          </SelectTrigger>
          <SelectContent>
            {options?.map((opt) => (
              <SelectItem key={opt?.value} value={opt?.value}>
                {opt?.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      );

    return (
      <Input
        id={name}
        placeholder={placeholder}
        {...(register || fieldProps)}
         disabled={disabled}
      />
    );
  };

  return (
    <div className={cn("", className)}>
      <label
        htmlFor={name}
        className="block text-sm font-medium text-[#09090B] mb-1"
      >
        {label}
        {required && <span className="text-red-500 ml-0.5">*</span>}
      </label>

      {control ? (
        <Controller
          name={name}
          control={control}
          render={({ field }) => renderField(field)}
        />
      ) : (
        renderField()
      )}

      {error && <p className="text-red-500 text-sm mt-1">{error.message}</p>}
    </div>
  );
};
